module.exports = __webpack_public_path__ + "img/P150T_weapon_47.6cd27d5c.png";